import { serializeTokens } from './tokens'
import { SerializedPoolConfig, PoolCategory } from './types'

const serializedTokens = serializeTokens()

const pools: SerializedPoolConfig[] = [
  {
    sousId: 0,
    stakingToken: serializedTokens.cake,
    earningToken: serializedTokens.cake,
    contractAddress: {
      97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
      2372: '0x27F890b996726e6e11272aC1bF0876dea7432450',
    },
    poolCategory: PoolCategory.AUTO,
    harvest: true,
    tokenPerBlock: '0.0016',
    sortOrder: 1,
    isFinished: false,
  }
  
]

export default pools
